export default __webpack_public_path__ + "static/media/img8.f923a95c.jpg";